import {
  Coproduction,
  ValidateCoproductionEmailResponse,
  validateCoproductionEmailDto,
  validateCoproductionPikKeyDto,
  ValidateCoproductionPixKeyResponse,
  CreateCoproductionSchema,
  UpdateCoproductionSchema,
} from '@interfaces/coproduction';
import { Product } from '@interfaces/product';
import { fetcher } from '@utils/fetcher';

const getApiUrl = (productId: Product['id']) =>
  `/api/products/${productId}/coproduction`;

export const createCoproduction = async (
  productId: Product['id'],
  dto: CreateCoproductionSchema,
): Promise<Coproduction> =>
  fetcher(`${getApiUrl(productId)}`, {
    method: 'POST',
    body: dto,
  });

export const deleteCoproduction = async (
  productId: Product['id'],
  id: Coproduction['id'],
): Promise<void> =>
  fetcher(`${getApiUrl(productId)}/${id}`, {
    method: 'DELETE',
  });

export const updateCoproduction = async (
  productId: Product['id'],
  id: Coproduction['id'],
  dto: UpdateCoproductionSchema,
): Promise<Coproduction> =>
  fetcher(`${getApiUrl(productId)}/${id}`, {
    method: 'PATCH',
    body: dto,
  });

export const findCoproductions = async (
  productId: Product['id'],
): Promise<Coproduction[]> => fetcher(getApiUrl(productId));

export const findCoproduction = async (
  productId: Product['id'],
  id: Coproduction['id'],
): Promise<Coproduction> => fetcher(`${getApiUrl(productId)}/${id}`);

export const validateCoproductionEmail = async (
  productId: Product['id'],
  dto: validateCoproductionEmailDto,
): Promise<ValidateCoproductionEmailResponse> =>
  fetcher(`${getApiUrl(productId)}/validateEmail`, {
    method: 'POST',
    body: dto,
  });

export const validateCoproductionPixKey = async (
  productId: Product['id'],
  dto: validateCoproductionPikKeyDto,
): Promise<ValidateCoproductionPixKeyResponse> =>
  fetcher(`${getApiUrl(productId)}/validatePixKey`, {
    method: 'POST',
    body: dto,
  });
